/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

export const Events = {
  MOUSE_KEY_DOWN_CODE: 0,
  ENTER_KEY_CODE: 13
};
